import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20">
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <h2 className="text-3xl md:text-4xl font-bold">Education</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="University of Port Harcourt, Rivers State, Nigeria"
            subTitle="2013 - 2020"
            result="B.Eng in Chemical Engineering"
            des="Obtained a Bachelor of Engineering degree in Chemical Engineering from the University of Port Harcourt, 
            acquiring a solid foundation in the principles and practices of Chemical Engineering.
             This educational journey provided me with essential knowledge and skills essential for a career in the field of Engineering"
          />
          <ResumeCard
            title="Andela React Training"
            subTitle="Andela  (Oct  2023)"
            result="Certificate of Completion"
            des="Completed a specialized training program in React, enhancing my proficiency in the technology and earning a certificate as a testament to my skills in frontend development."
          />
          <ResumeCard
            title="Holy Child College"
            subTitle="2009"
            result="Senior School Certificate Examination"
            des=" Completed secondary education at Holy Child School, 
            earning my Senior School Certificate."
          />
        </div>
      </div>
      {/* part Two */}

      {/* <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Software Engineer"
            subTitle="Decagon Institute"
            result="Nigeria"
            des="Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
          />
          <ResumeCard
            title="Web Developer & Trainer"
            subTitle="ALX Africa"
            result="Ibadan"
            des="Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
          />
          <ResumeCard
            title="Front-end Developer"
            subTitle="Freelancer"
            result="Remote"
            des="Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde. Tempora ex doloremque, labore, sunt repellat dolore, iste magni quos nihil ducimus libero ipsam."
          />
        </div>
      </div> */}
    </motion.div>
  );
};

export default Education;
